/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PostureCategoryModel {
    getFixupPrototypeFunction() { return PostureCategoryModel.fixupPrototype; }

    static newInstance(model: Partial<PostureCategoryModel>): PostureCategoryModel {
        let obj = Object.assign(new PostureCategoryModel(), model);
        PostureCategoryModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PostureCategoryModel>): PostureCategoryModel {
        if (!model) return null;
        return PostureCategoryModel.newInstance(<PostureCategoryModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PostureCategoryModel) {
        if (!obj) return;

        models.PostureCategoryModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PostureCategoryModel): boolean {
        Object.setPrototypeOf(obj, PostureCategoryModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.billable === undefined) {
            this.billable = 0;
        }
        if (this.non_billable === undefined) {
            this.non_billable = 0;
        }
    }

    /**
     * category name
     */
    category: string;

    /**
     * total count details
     */
    count: number;

    /**
     * billable count details
     */
    billable: number;

    /**
     * non_billable count details
     */
    non_billable: number;

}
